import type { CategorizationRule } from './types';

export const INCOME_RULES: CategorizationRule[] = [
  {
    category: "Salary & Wages",
    types: ["DIRECT_DEPOSIT"],
    keywords: [],
  },
  {
    category: "Salary & Wages",
    keywords: [
      "payroll",
      "salary",
      "direct dep",
      "remote online deposit",
    ],
  },
  {
    category: "Interest & Dividends",
    keywords: [
      "interest earned",
      "interest payment",
      "dividend",
    ],
  },
  {
    category: "Income - Other",
    keywords: ["zelle payment from", "zelle from"],
  },
  {
    category: "Income - Other",
    requiresMultiple: [
      ["venmo", "paypal"],
      ["from", "payment from"],
    ],
    keywords: [],
  },
  {
    category: "Salary & Wages",
    types: ["Deposit", "ACH_CREDIT", "Income"],
    keywords: [],
  },
  {
    category: "Bonus & Windfalls",
    keywords: ["promotional incentive", "cash redemption"],
  },
];
